import React, { forwardRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import rodoLogo from "../images/icons/logo_red.webp";
const Captcha = forwardRef(({ showCaptcha, handleCaptchaChange }, ref) => {
  return (
    <div className={`verification-gate ${showCaptcha ? "" : "closed"}`}>
      <img src={rodoLogo} alt="leaves" />
      <ReCAPTCHA ref={ref} sitekey={process.env.REACT_APP_CAPTCHA_KEY || "missing"} onChange={handleCaptchaChange} />
    </div>
  );
});

export default Captcha;
